import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import { Typography } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import styles from './styles';
import useTranslation from '../../../hooks/useTranslation';

const SITE_LINK = process.env.REACT_APP_SHARE_ICON_LINK;

const Footer = (props) => {
  const { classes } = props;
  const { t } = useTranslation();

  return (
    <div className={`${classes.footerMain} no-print`}>
      <Typography component="div">
        <div className={classes.footerContainer}>
          <Container maxWidth="lg" className={classes.container}>
            <Grid container className={classNames(classes.root, classes.footerRow)}>
              <Grid item xs={12} md={2} className={classes.footerItemGrid}>
                <ul>
                  <li>
                    <a className={classes.links} href={`${SITE_LINK}about-us`} title={t('about')}>{t('about')}</a>
                  </li>
                </ul>
              </Grid>
              <Grid item xs={12} md={2} className={classes.footerItemGrid}>
                <ul>
                  <li>
                    <a className={classes.links} href={`${SITE_LINK}services`} title={t('services')}>{t('services')}</a>
                  </li>
                </ul>
              </Grid>
              <Grid item xs={12} md={2} className={classes.footerItemGrid}>
                <ul>
                  <li>
                    <a className={classes.links} href={`${SITE_LINK}research`} title={t('research')}>{t('research')}</a>
                  </li>
                </ul>
              </Grid>
              <Grid item xs={12} md={2} className={classes.footerItemGrid}>
                <ul>
                  <li>
                    <a className={classes.links} href={`${SITE_LINK}evidence-hub`} title={t('evidenceHub')}>{t('evidenceHub')}</a>
                  </li>
                </ul>
              </Grid>
              <Grid item xs={12} md={2} className={classes.footerItemGrid}>
                <ul>
                  <li>
                    <a className={classes.links} href={`${SITE_LINK}support-us`} title={t('donate')}>{t('donate')}</a>
                  </li>
                </ul>
              </Grid>
            </Grid>
          </Container>
          <Typography component="div" className={classes.copyrightSection}>
            <div>
              <div className={classes.footerLine}>&nbsp;</div>
              <Container maxWidth="lg" className={classes.container}>
                <p>
                  {t('copyright')}
                  {` ${new Date().getFullYear()} `}
                  {t('allRightsReserved')}
                  <a href={`${SITE_LINK}terms-of-use`} rel="noopener noreferrer" title={t('termsOfUse')}>{t('termsOfUse')}</a>
                  {' '}
                  |
                  {' '}
                  <a href={`${SITE_LINK}privacy-policy`} rel="noopener noreferrer" title={t('privacyPolicy')}>{t('privacyPolicy')}</a>
                </p>
              </Container>
            </div>
          </Typography>
        </div>
      </Typography>
    </div>
  );
};

Footer.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Footer);
